"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.type = exports.defaultProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var type = exports.type = _propTypes["default"].shape({
  LastTradedPx: _propTypes["default"].number.isRequired,
  Rolling24HrPxChange: _propTypes["default"].number.isRequired,
  BestBid: _propTypes["default"].number.isRequired,
  BestOffer: _propTypes["default"].number.isRequired,
  Rolling24HrVolume: _propTypes["default"].number.isRequired,
  SessionLow: _propTypes["default"].number.isRequired,
  SessionHigh: _propTypes["default"].number.isRequired
});
var defaultProps = exports.defaultProps = {
  LastTradedPx: 0,
  Rolling24HrPxChange: 0,
  BestBid: 0,
  BestOffer: 0,
  Rolling24HrVolume: 0,
  SessionLow: 0,
  SessionHigh: 0
};